var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.1H1M19 11.475V7.96C19 6.36385 19 5.56577 18.673 4.95613C18.3854 4.41986 17.9265 3.98387 17.362 3.71063C16.7202 3.4 15.8802 3.4 14.2 3.4H5.8C4.11984 3.4 3.27976 3.4 2.63803 3.71063C2.07354 3.98387 1.6146 4.41986 1.32698 4.95613C1 5.56577 1 6.36385 1 7.96V15.94C1 17.5362 1 18.3342 1.32698 18.9439C1.6146 19.4802 2.07354 19.9161 2.63803 20.1894C3.27976 20.5 4.11984 20.5 5.8 20.5H10M14 1.5V5.3M6 1.5V5.3M12.5 17.65L14.5 19.55L19 15.275",
    stroke: "#63C0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.30923feab3d6c5387d36c7eaedab76de.svg";
export { ForwardRef as ReactComponent };